import React from 'react';

interface IProps {
    type: string;
    icon: string;
    header: string;
    description: string;
    onClick: Function;
}

export const Alert: React.SFC<IProps> = ({type, icon, header, description, onClick}) => {
    return (
        <div className={`tile alert alert--${type}`}>
            <a className='alert__close' onClick={() => onClick()}>&times;</a>
            <div className='alert__icon'>
                <i className={`icon icon-${icon}`}></i>
            </div>
            <div className='alert__content'>
                <p className='alert__header'>{header}</p>
                <p className='alert__description'>{description}</p>
            </div>
        </div>
    );
};
